import i18n from "../i18n";

const WorkTaskPriorities = {
  0: {
    name: i18n.global.t("work.priorities.low"),
    color: "badge-outline",
    id: 0,
    icon: "arrow-down",
  },
  1: {
    name: i18n.global.t("work.priorities.medium"),
    color: "bg-info text-body",
    id: 1,
    icon: "arrow-right",
  },
  2: {
    name: i18n.global.t("work.priorities.high"),
    color: "bg-warning text-dark",
    id: 2,
    icon: "arrow-up",
  },
  3: {
    name: i18n.global.t("work.priorities.urgent"),
    color: "bg-danger text-white",
    id: 3,
    icon: "flash",
  },
};

export default WorkTaskPriorities;
